import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

// Firebase configuration from environment variables
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyCZ8--BudMVsdWsDhSv0Bk6-2KFfJMih8o",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "pehchanpe-17092020.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "pehchanpe-17092020",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "pehchanpe-17092020.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "113743135011",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:113743135011:web:c4d81333c08bd4c4accc96",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-6G69T40CHD"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
export default app;
